<template>
    <div>
        <el-button type="text" size="mini" icon="el-icon-plus" class="attr-add-btn" @click="bindBtnClick">{{ $tt("添加") }}</el-button>
        <div v-if="curComponent.style.bindPage" style="margin-top: 6px;">
            <el-tag
                closable
                type="info"
                @close="tagClose"
            >
                {{ $displayLabel(curComponent.style.bindPage.label) }}
            </el-tag>
        </div>
        <el-dialog
            :title="$tt('绑定子页面')"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleClose"
            :modal-append-to-body="true"
            :append-to-body="true"
            :destroy-on-close="true"
        >
            <span v-if="childPageDatas.length === 0" class="empty-tip">
                <i class="el-icon el-icon-warning"></i>
                {{ $tt("请先添加子页面，再去绑定") }}
            </span>
            <div v-else>
                <div v-for="item in childPageDatas" :key="item.value" :class="['child-page-item', selectedPage && String(selectedPage.value) === String(item.value) ? 'selected' : '']" @click="() => {childItemClick(item)}">
                    {{ $displayLabel(item.label) }}
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">{{ $tt("取 消") }}</el-button>
                <el-button type="primary" @click="confirmClick">{{ $tt("确 定") }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    data() {
        return {
            dialogVisible: false,
            childPageDatas: [],
            selectedPage: null
        };
    },
    computed: {
        ...mapState([
            "pageOptions",
            "selectedCurrentPage",
            "curComponent"
        ]),
    },
    methods: {
        tagClose() {
            this.$store.commit("setShapeSingleStyle", {
                key: 'bindPage',
                value: null
            });
        },
        childItemClick(item) {
            if (!this.selectedPage || String(this.selectedPage.value) !== String(item.value)) {
                this.selectedPage = item;
            }
        },
        resolveMainPageNode() {
            const sel = this.selectedCurrentPage != null
                ? String(this.selectedCurrentPage)
                : "";
            if (!sel) {
                return null;
            }
            for (let i = 0; i < this.pageOptions.length; i++) {
                const page = this.pageOptions[i];
                if (String(page.value) === sel) {
                    return page;
                }
                if (page.children && page.children.length) {
                    const isChild = page.children.some(
                        (child) => String(child.value) === sel
                    );
                    if (isChild) {
                        return page;
                    }
                }
            }
            return null;
        },
        bindBtnClick() {
            const mainPage = this.resolveMainPageNode();
            const children = mainPage && Array.isArray(mainPage.children)
                ? mainPage.children.slice()
                : [];
            this.childPageDatas = children;
            this.selectedPage = this.curComponent.style.bindPage
                ? JSON.parse(JSON.stringify(this.curComponent.style.bindPage))
                : null;
            this.$nextTick(() => {
                this.dialogVisible = true;
            });
        },
        handleClose() {
            this.dialogVisible = false;
            this.selectedPage = null;
        },
        confirmClick() {
            if (this.selectedPage) {
                this.$store.commit("setShapeSingleStyle", {
                    key: "bindPage",
                    value: JSON.parse(JSON.stringify(this.selectedPage)),
                });
            }
            this.handleClose();
        }
    }
}
</script>
<style lang="scss" scoped>
.empty-tip {
    color: #999999;
    font-size: 12px;
}
.child-page-item {
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 14px;
    border: 1px solid rgb(235, 235, 235);
    cursor: pointer;
    & + .child-page-item {
        border-top: none;
    }
    &:hover, &.selected {
        background: #bdd9f9;
    }
}
</style>
